import { waMessages } from "@/lib/whatsapp";
import WhatsAppLink from "@/components/feature/WhatsAppLink";
import Reveal from "@/components/feature/Reveal";

export default function Story() {
  return (
    <section id="hikayemiz" className="scroll-mt-24 bg-background-200">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.28em] text-accent-600 md:text-sm">
            Hikâyemiz
          </p>
        </Reveal>

        <div className="mt-6 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
          <Reveal className="lg:col-span-6">
            <h2 className="font-heading text-3xl leading-tight text-primary-800 md:text-5xl">
              New York'tan Bursa'ya uzanan bir salon hikâyesi.
            </h2>
            <div className="mt-6 h-px w-16 bg-accent-500" aria-hidden="true"></div>
            <p className="mt-6 font-heading text-xl text-secondary-600 md:text-2xl">
              33 yıllık saç tasarımı tecrübesiyle, Odunluk'ta VIP butik salon deneyimi.
            </p>
          </Reveal>

          <Reveal className="lg:col-span-6" delay={120}>
            <p className="text-base leading-relaxed text-foreground-700 md:text-lg">
              Otuz üç yıllık saç tasarımı tecrübesini New York'tan Bursa'ya taşıyan gülaYonar,
              Odunluk'ta samimi ve özenli bir butik salon deneyimi sunuyor. Her misafirimizle birebir
              ilgileniyor; saçınızı, yüz hatlarınızı ve yaşam tarzınızı dinleyerek size özel bir stil
              planı oluşturuyoruz. Kalabalık ve aceleci bir ortam yerine, kendinize ayırdığınız bu
              zamanda rahat hissetmenizi ve salonumuzdan güvenle ayrılmanızı önemsiyoruz. Her randevu
              öncesinde kişiye özel stil görüşmesiyle, istediğiniz görünüme birlikte ulaşmayı
              hedefliyoruz.
            </p>
            <WhatsAppLink
              message={waMessages.generalQuestions}
              label="Salonla Tanışın"
              variant="outline"
              size="md"
              sourceSection="story"
              className="mt-8"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}